import { motion } from "framer-motion";
import { LeadForm } from "./LeadForm";

const TITLE_LINES = [
  [{ t: "Compila e scarica" }],
  [{ t: "la guida " }, { t: "gratuita", accent: true }],
  [{ t: "per ottimizzare i tuoi" }],
  [{ t: "processi aziendali" }],
];

const lineVariant = {
  hidden: { y: "110%" },
  show: (i) => ({
    y: "0%",
    transition: { duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: 0.15 + i * 0.12 },
  }),
};

export const Hero = () => {
  return (
    <section className="relative overflow-hidden px-6 pt-32 pb-24 sm:px-10 lg:px-16 lg:pt-40 lg:pb-32">
      {/* Ambient purple glows */}
      <div className="pointer-events-none absolute -left-40 top-10 h-[520px] w-[520px] rounded-full bg-[#7c3aed]/20 blur-[130px]" />
      <div className="pointer-events-none absolute -right-32 bottom-0 h-[420px] w-[420px] rounded-full bg-[#7c3aed]/10 blur-[130px]" />

      <div className="relative mx-auto flex max-w-4xl flex-col items-center text-center">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6 }}
          className="mb-8 flex items-center gap-3"
        >
          <span className="h-px w-10 bg-[#7c3aed]" />
          <span className="text-[0.7rem] font-semibold uppercase tracking-[0.32em] text-[#a1a1aa]">
            Guida AI · Instagram
          </span>
          <span className="h-px w-10 bg-[#7c3aed]" />
        </motion.div>

        <h1
          className="text-4xl font-light leading-[1.22] tracking-tight sm:text-5xl lg:text-[4.2rem]"
          data-testid="hero-title"
        >
          {TITLE_LINES.map((line, i) => (
            <span key={i} className="block overflow-hidden py-[0.02em]">
              <motion.span
                className="block"
                custom={i}
                variants={lineVariant}
                initial="hidden"
                animate="show"
              >
                {line.map((seg, j) => (
                  <span key={j} className={seg.accent ? "text-[#a78bfa]" : ""}>
                    {seg.t}
                  </span>
                ))}
              </motion.span>
            </span>
          ))}
        </h1>

        {/* Form */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6, duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="mt-14 w-full max-w-md text-left"
        >
          <LeadForm />
        </motion.div>
      </div>
    </section>
  );
};
